var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSideArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "url(#pattern0_2484_394)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2484_394",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2484_394",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2484_394",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAAAuBJREFUeAHtnUuS0zAUReU4RF4BllkLm2ApsAKm/BnyZ8ifzbEAqBSV4OpOR6krXZcon560y867dp2T53THthQCPxCAAAQgAAEIQAACEIAABCAAAQhA4CSBfjfdCyHcOrmRlcsS2MTpQR/T7y6OP5GyLPtrezvI2Av5KyX9QMo1TMusuCoDKctwP7mXm2TMpHynU06iq78yJ+OflNvfQgjb+kdA4pHAJk73D8Av+j2kL0g54qu/sB3u3O1j+nWRjOMHPZ1S38QsUZHSD+krnTKDWHtRlMLpq7aIeR5S5jQaWRalfOb0ZRSIFCNcNVqU8imE0Kv7pC5DQJKySx9DCJtMNJtVAkhRyRnrRCkf6JT2pLxHClKMBBqMFk9fdIrTpSQlTu84fRmtiFLeIqVNKZ3xsNYdrXXK+CaEgBTXWwcpLrIFuaKU13RKAfRcqSjlFVJyZAu2K1K2cXqJlALouVJNyvgil8v2AgJIKYDnKhWlPHcdD7n7C+3CfV/bOCLF+e7RpKRnzmNafbYo5enqwTkBIMVJV8wWpTwRd0fZJQREKY8vyeY1IgGkiOCcZaKUR85jWn22JGVID1cPzgUAIS6yQq4kIyZOWQLrbIkog7+0smSFFyBDgOYqEWXwj6FDiCiD77OQ4SDQUKbYGXz97nCoyeAClcMFVwstVMVQsTO480TkfbYMGWfxLLtRk8GNchZLiow+jtxK6rAhyuBm64Zk8IwIMhwEGsrUTlPT/jlDnp6q7bFABuOgNCKDx6Jri9jnSZ2xSwwcgAwHgYYy6Yz/XwbDMzkcip3BqHLIcBBoKFPqjCExCKbDoSiDsXuR4SDQUKbYGYz/7nCIDAdVMVOUwXQVIu+zZYqMLjKhy1moJRuZ8qiEnqmWScFMYEtic1K6mJg2rwSwUnuTlC4y26fCs0rNVSnIqIK1LOQghcmJyzhWrWb67qo4CYMABCAAAQhAAAIQgAAEIAABCECgmMAfMlcn35SVYaMAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideArrow);
export default __webpack_public_path__ + "static/media/side-arrow.ec12143797899359fa852c830b1171c2.svg";
export { ForwardRef as ReactComponent };